import DefaultAvatar, { AvatarType } from 'js/components/Avatar/Avatar'
import cx from 'js/lib/helpers/cx'

import styles from './Avatar.module.css'

const Avatar = ({ className, ...rest }: AvatarType) => (
    <DefaultAvatar className={cx(styles.avatar, className)} {...rest} />
)

export default Avatar
